import { cn } from "@/lib/utils"

export function NativeSelect({ className, ...props }) {
  return (
    <select
      className={cn(
        "flex h-8 w-full rounded-md border border-border bg-background px-3 py-1 text-sm text-foreground",
        "focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}
